<template>
	<el-dialog class="z-share" @close="deepClear" :close-on-click-modal="false" :size="'large'" title="职级分配" :visible.sync="popFlag">
		<div class="head-center-text">{{ "" }}</div>
		<div class="remind">
			<p class="remind-rank">可分配职级：{{ rest_level }}级</p>
			<!-- <p class="remind-notice">温馨提示：请在{{ end_date[1] }}月{{ end_date[2] }}日前完成分配，逾期未分配将纳入下个分配周期</p> -->
		</div>
		<table class="RankTable" cellpadding="0" cellspacing="0" width="100%">
			<thead>
				<tr>
					<td>姓名</td>
					<td>任务数</td>
					<td>异常任务数</td>
					<td>罚单数</td>
					<td>罚币数量(币)</td>
					<td>职级</td>
					<td>分配职级</td>
				</tr>
			</thead>
			<tbody v-form:pmt>
				<!--成员  -->
				<tr v-for="(item,index) in users" :key="item.id">
					<td>{{ item.real_name }}</td>
					<td>{{ item.task_size }}</td>
					<td>{{ item.error_task_size }}</td>
					<td>{{ item.ticket_size }}</td>
					<td>{{ item.ticket_sum }}</td>
					<td>{{ item.staffing_grade }}</td>
					<td>
						<input type="text" rule="bonus" v-tar="sub_arr[index]" v-model="sub_arr[index]">
					</td>
				</tr>
			</tbody>
		</table>
		<p class="bonusNotice">注*异常任务指的是执行中被取消的任务</p>
		<div slot="footer" class="dialog-footer">
			<el-button @click="popFlag = false">取 消</el-button>
			<el-button type="primary" :loading="loading" @click="pmt_confirm">完成</el-button> 
		</div>
	</el-dialog>
</template>


<script type="text/ecmascript-6">

export default {
	props: ["showFlag","pmt"],
	data() {
		return {
			loading:false,  //完成按钮 等待
			data:{},
			sub_arr:[],
		}
	},
	computed: {
		popFlag: {
			// getter
			get: function () {
				return this.showFlag;
			},
			// setter
			set: function (newValue) {
				if (!newValue) {
					this.$emit("close");
				}
			}
		},
		users(){
			return this.data.userList;
		},
		pmt_dist(){  //分配的对象
			let res = {};
			this.users.forEach((user,index)=>{
				res[user.id] = this.sub_arr[index]; 
			});
			return res;
		},
		rest_level(){  //剩余可分配职级
			let sum = 0;
			this.sub_arr.forEach(val =>{
				val = parseInt(val)
				if(!isNaN(val)){
					sum+= val;
				}
			})
			return this.pmt?this.pmt.balance - sum : 0;
		},
		// end_date(){
		// 	return this.pmt.dist_end?this.pmt.dist_end.split(" ")[0].split("-"):[];
		// },
	},

	watch:{
		popFlag(val){
			if(val){
				let url = `api/manager/pmt_level_detail/info`;
				this.$http.get(url).then(res=>{
					if(res.status  == 200){
						this.data = res.res_data;
					}
				});
			}
		},
	},

	methods: {
		deepClear() {  //清空数据
			this.$form.clear("pmt");
			this.sub_arr = [];
		},
		pmt_confirm(){  //职级分配完成
			let res = this.$form.check("pmt");
			console.log(`验证结果： ${res}`);
			if (!res) {
				return;
			}

			if(this.rest_level < 0){
				this.errorTip("分配超标");
				return;
			}

			this.loading = true;
			this.$http.post("api/manager/pmt_level_detail",{
				dist:this.pmt_dist
			}).then(res=>{
				if(res.status == 200){
					this.popFlag = false;
					this.successTip("分配成功");
					this.$emit("getInfo");
					this.$func.getBuMembers(true);   //更新用户数据
				}
				this.loading = false;
			}).catch(error=>{
				this.errorTip("分配失败");
				this.loading = false;
			});
		},
		
	},

}
</script>


<style lang="less" scoped>
// #bonusWrap {
// 	background: #ffffff;
// 	box-shadow: 0px 0px 2px 0px rgba(128, 128, 128, 0.50);
// 	border-radius: 3px;
// 	width: 980px;
// 	height: 540px;
// 	position: absolute;
// 	left: 50%;
// 	top: 50%;
// 	transform: translate(-490px, -270px);
// 	z-index: 104;
// 	font-size: 12px;
// 	color: #808080;
// }

// .header {
// 	background: #f0f0f0;
// 	box-shadow: inset 0px -1px 0px 0px rgba(183, 183, 183, 0.50);
// 	height: 36px;
// 	line-height: 36px;
// 	font-size: 14px;
// 	color: #4d4d4d;
// 	letter-spacing: 0.72px;
// 	padding-left: 10px;
// }

// .header>span {
// 	position: absolute;
// 	right: 5px;
// 	top: 5px;
// 	width: 26px;
// 	height: 26px;
// 	background: url(../../assets/image/bigX.png) no-repeat;
// 	cursor: pointer;
// }
// .head-center-text{
// 		top: 0;
// 		position: absolute;
// 		left: 0;
// 		right: 0;
// 		text-align: center;
// 		line-height: 36px;
// 		color: #01b6ad;
// 		font-weight: 600;
// 	}

.remind {
	padding-left: 14px;
}

.remind-rank {
	margin: 20px 0 10px 0;
}

.remind-notice {
	color: #f5a623;
}

.RankTable {
	text-align: center;
	margin-top: 26px;
}

.RankTable thead tr {
	background: #f2f2f2;
	height: 34px;
	font-size: 14px;
	color: #323232;
	letter-spacing: 0.99px;
}

.RankTable tbody td {
	height: 44px;
	border-bottom: 1px solid #e6e6e6;
	font-size: 12px;
	color: #808080;
	letter-spacing: 1.33px;
}

.RankTable tr>td:nth-of-type(1) {
	width: 11%
}

.RankTable tr>td:nth-of-type(2) {
	width: 10%
}

.RankTable tr>td:nth-of-type(3) {
	width: 15%
}

.RankTable tr>td:nth-of-type(4) {
	width: 15%
}

.RankTable tr>td:nth-of-type(5) {
	width: 15%
}

.RankTable tr>td:nth-of-type(6) {
	width: 15%
}

.RankTable tbody td input {
	border: 1px solid #d4d4d4;
	border-radius: 2px;
	width: 84px;
	height: 22px;
	padding-left: 10px;
}

.bonusNotice {
	text-align: right;
	font-size: 12px;
	color: #808080;
	letter-spacing: 0.99px;
	margin: 10px 20px 0 0;
}

.btnGroup {
	position: absolute;
	bottom: 20px;
	right: 0;
}

.btnGroup>span {
	float: right;
	border-radius: 2px;
	width: 72px;
	height: 28px;
	color: #fff;
	line-height: 28px;
	text-align: center;
	margin-right: 20px;
	cursor: pointer;
	background: #108ee9;
}
</style>



// WEBPACK FOOTER //
// rankShare.vue?5be36588